import { createContext } from 'react'
import { BankListContextType } from './typings'
import { BANKLIST_DEFAULT_SELECTION_VALUES } from '../../utils/loanSelector.utils'

export const BankListContext = createContext<BankListContextType>({
  loanSelectorState: {
    purpose: BANKLIST_DEFAULT_SELECTION_VALUES.purpose,
    amount: BANKLIST_DEFAULT_SELECTION_VALUES.amount,
    term: BANKLIST_DEFAULT_SELECTION_VALUES.term,
  },
  handleCTAButtonClick: undefined,
  handleLoanSelectorValueChange: undefined,
})
